import React, {FC} from 'react';
import styled from 'styled-components';

import {hoverSelector} from '../../../../../libs/shared/helpers/src/browser/hoverHelpers';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface SidePanelManagerSectionLinkProps {
  onClick?: Handler;
}

/*
 * Style.
 */

const StyledLinkDiv = styled.div`
  display: grid;
  grid-auto-columns: auto;
  grid-auto-flow: column;
  grid-column-gap: 6px;
  align-items: center;

  color: ${(p) => p.theme.palette.blue.shade40};

  ${hoverSelector} {
    color: ${(p) => p.theme.palette.blue.shade50};
  }
`;

const StyledTextDiv = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.medium};
`;

/*
 * Component.
 */

export const SidePanelManagerSectionLink: FC<SidePanelManagerSectionLinkProps> = (props) => (
  <ChromelessButton {...props}>
    <StyledLinkDiv>
      <StyledTextDiv>{props.children}</StyledTextDiv>
      <Icon name="externalLinkSmall" />
    </StyledLinkDiv>
  </ChromelessButton>
);
